if ($('#dashboard-sidebar-vue').length) {
    var app = new Vue({
        el: '#dashboard-sidebar-vue',
        data: {
            count: 0,
            msgsCount: 0
        },
        methods: {
            getPendingConnectionsCount() {
                this.count = 0;
                axios.get('/api/v1/get-pending-connections-count')
                    .then((response) => {
                        if (response.data) {
                            this.count = response.data;
                        }
                    }).catch((error) => {
                    console.log(error);
                });
            },
            getUnreadMessagesCount() {
                this.msgsCount = 0;
                axios.get('/get-unread-messages-count')
                    .then((response) => {
                        if (response.data) {
                            this.msgsCount = response.data;
                        }
                    }).catch((error) => {
                    console.log(error);
                });
            },
        },
        mounted() {
            this.getPendingConnectionsCount();
            this.getUnreadMessagesCount();
        }
    });
}